import { createBrowserRouter } from 'react-router-dom'

import SignUp from 'components/Auth/SignUp'
import SignUpConfirm from 'components/Auth/SignUpConfirm'
import SignIn from 'components/Auth/SignIn'
import ResetPassword from 'components/ResetPassword/ResetPassword'
import ResetPasswordRequested from 'components/ResetPassword/ResetPasswordRequested'
import PageWrapper from 'components/PageWrapper/PageWrapper'
import Contracts from 'components/Contracts/Contracts'
import ContractList from 'components/Contracts/ContractList/ContractList'
import ContractItem from 'components/Contracts/ContractItem/ContractItem'
import ContractDocuments from 'components/Contracts/ContractDocuments/ContractDocuments'
import ContractCancel from 'components/Contracts/ContractCancel/ContractCancel'
// import ContractGuarantees from 'components/Contracts/ContractGuarantees/ContractGuarantees'
import Claims from 'components/Claims/Claims'
import ClaimList from 'components/Claims/ClaimList/ClaimList'
import ClaimItem from 'components/Claims/ClaimItem/ClaimItem'
import ClaimApplication from 'components/Claims/ClaimApplication/ClaimApplication'
import CircumstancesForm from 'components/Claims/ClaimApplication/CircumstancesForm/CircumstancesForm'
import ContactForm from 'components/Claims/ClaimApplication/ContactForm/ContactForm'
import InsuredPersonSelection from 'components/Claims/ClaimApplication/InsuredPersonSelection/InsuredPersonSelection'
import ContractSelection from 'components/Claims/ClaimApplication/ContractSelection/ContractSelection'
import Contacts from 'components/Contacts/Contacts'
import ContactSummary from 'components/Contacts/ContactSummary/ContactSummary'
import ContactMainForm from 'components/Contacts/ContactMainForm/ContactMainForm'
import PasswordForm from 'components/Contacts/PasswordForm/PasswordForm'
import PaymentMethodForm from 'components/Contacts/PaymentMethodForm/PaymentMethodForm'
import ContactUs from 'components/ContactUs/ContactUs'
import NotFoundPage from 'components/NotFoundPage/NotFoundPage'
import DocumentForm from 'components/Claims/ClaimApplication/DocumentForm/DocumentForm'

// Subscription
import Subscription from 'components/Subscription/Subscription'
import SubscriptionMain from 'components/Subscription/SubscriptionMain/SubscriptionMain'
import MainForm from 'components/Subscription/MainForm/MainForm'
import ContactSubscriptionForm from 'components/Subscription/ContactForm/ContactForm'
import AddressForm from 'components/Subscription/AddressForm/AddressForm'
import Recap from 'components/Subscription/Recap/Recap'
import CreditCardForm from 'components/Subscription/CreditCardForm/CreditCardForm'
import SuccessPage from 'components/Subscription/SuccessPage/SuccessPage'
import Signature from 'components/Subscription/Signature/Signature'
import UnsuccessPage from 'components/Subscription/UnsuccessPage/UnsuccessPage'
import Expenses from 'components/Subscription/Expenses/Expenses'

// Freemium
import Freemium from 'components/Freemium/Freemium'
import FreemiumMain from 'components/Freemium/FreemiumMain/FreemiumMain'
import Profil from 'components/Freemium/Profil/Profil'
import Address from 'components/Freemium/Address/Address'
import ContactsFreemium from 'components/Freemium/Contacts/Contacts'
import Partner from 'components/Freemium/Partner/Partner'
import More from 'components/Freemium/More/More'
import Children from 'components/Freemium/Children/Children'
import Summary from 'components/Freemium/Summary/Summary'
import Payment from 'components/Freemium/Payment/Payment'
import SignaturePage from 'components/Freemium/Signature/Signature'
import SignatureChoice from 'components/Freemium/SignatureChoice/SignatureChoice'
import Success from 'components/Freemium/Success/Success'
import Unsuccess from 'components/Freemium/Unsuccess/Unsuccess'

// Reporting
import Wrapper from 'components/reporting/Wrapper/Wrapper'
import AuthReporting from 'components/reporting/pages/Auth/SignIn/Signin'
import SignupReporting from 'components/reporting/pages/Auth/Signup/Signup'
import PasswordLost from 'components/reporting/pages/Auth/PasswordLost/PasswordLost'
import PasswordReset from 'components/reporting/pages/Auth/PasswordReset/PasswordReset'
import Overview from 'components/reporting/pages/Overview/Overview'
import Production from 'components/reporting/pages/Production/Production'
import ClaimsReport from 'components/reporting/pages/Claims/Claims'
import ContactReporting from 'components/reporting/pages/Contact/Contact'
import ReportingSignUpConfirm from 'components/reporting/pages/Auth/SignupConfirm/SignupConfirm'
import NotFoundPageReporting from 'components/reporting/pages/NotFoundPage/NotFoundPage'
import OverviewUnified from 'components/reporting/pages/Overview/OverviewUnified'
import ProductionUnified from 'components/reporting/pages/Production/ProductionUnified'
import ClaimsReportUnified from 'components/reporting/pages/Claims/ClaimsUnified'


// RC Pro
import RCProWrapper from 'components/RCPro/Wrapper/Wrapper'
import RCProIntro from 'components/RCPro/pages/Intro/Intro'
import RCProCustomer from 'components/RCPro/pages/Customer/Customer'
import RCProInsured from 'components/RCPro/pages/Insured/Insured'
import RCProCompany from 'components/RCPro/pages/Company/Company'
import RCProActivity from 'components/RCPro/pages/Activity/Activity'
import RCProTurnover from 'components/RCPro/pages/Turnover/Turnover'
import RCProContacts from 'components/RCPro/pages/Contacts/Contacts'
import RCProEstimate from 'components/RCPro/pages/Estimate/Estimate'
import RCProLoading from 'components/RCPro/pages/Loading/Loading'
import RCProActivation from 'components/RCPro/pages/Activation/Activation'
import RCProFrequency from 'components/RCPro/pages/Frequency/Frequency'
import RCProResume from 'components/RCPro/pages/Resume/Resume'
import RCProPaymentChoice from 'components/RCPro/pages/PaymentChoice/PaymentChoice'
import RCProPayment from 'components/RCPro/pages/Payment/Payment'
import RCProSignatureChoice from 'components/RCPro/pages/SignatureChoice/SignatureChoice'
import RCProSignature from 'components/RCPro/pages/Signature/Signature'
import RCProOups from 'components/RCPro/pages/Oups/Oups'

const RCChildren = [
  {
    path: '',
    element: <RCProIntro />
  },
  {
    path: 'customer',
    element: <RCProCustomer />
  },
  {
    path: 'insured',
    element: <RCProInsured />
  },
  {
    path: 'company',
    element: <RCProCompany />
  },
  {
    path: 'activity',
    element: <RCProActivity />
  },
  {
    path: 'turnover',
    element: <RCProTurnover />
  },
  {
    path: 'contacts',
    element: <RCProContacts />
  },
  {
    path: 'estimate',
    element: <RCProEstimate />
  },
  {
    path: 'loading',
    element: <RCProLoading />
  },
  {
    path: 'activation',
    element: <RCProActivation />
  },
  {
    path: 'frequency',
    element: <RCProFrequency />
  },
  {
    path: 'resume',
    element: <RCProResume />
  },
  {
    path: 'payment-choice',
    element: <RCProPaymentChoice />
  },
  {
    path: 'payment',
    element: <RCProPayment />
  },
  {
    path: 'signature-choice',
    element: <RCProSignatureChoice />
  },
  {
    path: 'signature',
    element: <RCProSignature />
  },
  {
    path: 'oups',
    element: <RCProOups />
  },
  {
    path: '*',
    element: <RCProIntro />
  },
]

const router = createBrowserRouter([
  {
    path: '/',
    element: <PageWrapper />,
    children: [
      {
        path: 'contracts',
        element: <Contracts />,
        children: [
          {
            path: '',
            element: <ContractList />,
          },
          {
            path: ':id',
            element: <ContractItem />,
          },
          {
            path: ':id/documents',
            element: <ContractDocuments />,
          },
          // not in mvp1
          // {
          //   path: ':id/guarantees',
          //   element: <ContractGuarantees />,
          // },
          {
            path: ':id/cancel',
            element: <ContractCancel />,
          },
        ],
      },
      {
        path: 'claims',
        element: <Claims />,
        children: [
          {
            path: '',
            element: <ClaimList />,
          },
          {
            path: ':id',
            element: <ClaimItem />,
          },
          {
            path: 'new',
            element: <ClaimApplication />,
            children: [
              {
                path: '',
                element: <ContractSelection />,
              },
              {
                path: 'insured-person',
                element: <InsuredPersonSelection />,
              },
              {
                path: 'contacts',
                element: <ContactForm />,
              },
              {
                path: 'circumstances',
                element: <CircumstancesForm />,
              },
              {
                path: 'documents',
                element: <DocumentForm />,
              },
            ],
          },
        ],
      },
      {
        path: 'contacts',
        element: <Contacts />,
        children: [
          {
            path: '',
            element: <ContactSummary />,
          },
          {
            path: 'edit',
            element: <ContactMainForm />,
          },
          {
            path: 'edit/password',
            element: <PasswordForm />,
          },
          {
            path: 'edit/payment-method',
            element: <PaymentMethodForm />,
          },
        ],
      },
      {
        path: 'contact-us',
        element: <ContactUs />,
      },
      {
        path: 'sign-in',
        element: <SignIn />,
      },
      {
        path: 'sign-up',
        element: <SignUp />,
      },
      {
        path: 'sign-up-confirm',
        element: <SignUpConfirm />,
      },
      {
        path: 'reset-password',
        element: <ResetPassword />,
      },
      {
        path: 'reset-password/requested',
        element: <ResetPasswordRequested />,
      },
    ],
  },
  {
    path: 'subscription/:id',
    element: <Subscription />,
    children: [
      {
        path: '',
        element: <SubscriptionMain />,
      },
      {
        path: 'main',
        element: <MainForm />,
      },
      {
        path: 'contacts',
        element: <ContactSubscriptionForm />,
      },
      {
        path: 'address',
        element: <AddressForm />,
      },
      {
        path: 'expenses',
        element: <Expenses />,
      },
      {
        path: 'recap',
        element: <Recap />,
      },
      {
        path: 'credit-card',
        element: <CreditCardForm />,
      },
      {
        path: 'signature',
        element: <Signature />,
      },
      {
        path: 'success',
        element: <SuccessPage />,
      },
      {
        path: 'cannot_continue_the_subscription',
        element: <UnsuccessPage />,
      },
    ],
  },
  {
    path: 'freemium/:id',
    element: <Freemium />,
    children: [
      {
        path: '',
        element: <FreemiumMain />,
      },
      {
        path: 'profil',
        element: <Profil />,
      },
      {
        path: 'address',
        element: <Address />,
      },
      {
        path: 'contacts',
        element: <ContactsFreemium />,
      },
      {
        path: 'partner',
        element: <Partner />,
      },
      {
        path: 'more',
        element: <More />,
      },
      {
        path: 'children',
        element: <Children />,
      },
      {
        path: 'summary',
        element: <Summary />,
      },
      {
        path: 'payment',
        element: <Payment />,
      },
      {
        path: 'signature-choice',
        element: <SignatureChoice />,
      },
      {
        path: 'signature',
        element: <SignaturePage />,
      },
      {
        path: 'success',
        element: <Success />,
      },
      {
        path: 'cannot_continue_the_subscription',
        element: <Unsuccess />,
      },
    ],
  },
  {
    path: 'reporting',
    element: <Wrapper />,
    children: [
      {
        path: 'signin',
        element: <AuthReporting />
      },
      {
        path: 'signup',
        element: <SignupReporting />
      },
      {
        path: 'signup-confirm',
        element: <ReportingSignUpConfirm />
      },
      {
        path: 'password-lost',
        element: <PasswordLost />
      },
      {
        path: 'password-reset',
        element: <PasswordReset />
      },
      {
        path: 'overview',
        element: <Overview />,
      },
      {
        path: 'overviewoptimized',
        element: <OverviewUnified />,
      },
      {
        path: 'production',
        element: <Production />,
      },
      {
        path: 'productionoptimized',
        element: <ProductionUnified />,
      },
      {
        path: 'claims',
        element: <ClaimsReport />,
      },
      {
        path: 'claimsoptimized',
        element: <ClaimsReportUnified />,
      },
      {
        path: 'contact',
        element: <ContactReporting />,
      },
      {
        path: '*',
        element: <NotFoundPageReporting />,
      },
    ],
  },
  {
    path: 'rc-pro/:id',
    element: <RCProWrapper />,
    children: RCChildren
  },
  {
    path: 'rca/:id',
    element: <RCProWrapper />,
    children: RCChildren
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
])

export default router
